import { Phone, MessageCircle, Mail } from "lucide-react";
import { Chapter, Reveal } from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { TEL_LINK, PHONE_DISPLAY, WHATSAPP_URL, WHATSAPP_DISPLAY, EMAIL_DISPLAY } from "../lib/site";
import { useLang } from "../lib/i18n";

export const ContactForm = () => {
  const { t } = useLang();

  const ROWS = [
    { icon: Phone, label: t.rowCall, value: PHONE_DISPLAY, href: TEL_LINK, testid: "contact-phone-link" },
    { icon: MessageCircle, label: "WhatsApp", value: WHATSAPP_DISPLAY, href: WHATSAPP_URL, testid: "contact-whatsapp-link" },
    { icon: Mail, label: t.fEmail, value: EMAIL_DISPLAY, href: `mailto:${EMAIL_DISPLAY}`, testid: "contact-email-link" },
  ];

  return (
    <section id="faq" data-testid="contact-form-section" className="relative bg-[#181510] py-24 md:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-12 lg:px-20">
        <div className="lg:col-span-5">
          <Chapter number="05" label={t.chFaq} testid="contact-chapter" tone="dark" />
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-archivo text-3xl font-black tracking-tight text-white md:text-5xl" data-testid="faq-heading">
              {t.faqHeading}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70 sm:text-base" data-testid="faq-copy">
              {t.faqCopy}
            </p>
          </Reveal>
          <div className="mt-10 space-y-3">
            {ROWS.map((r, i) => (
              <Reveal key={r.testid} delay={0.2 + i * 0.08}>
                <a
                  href={r.href}
                  target={r.href.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  className="group flex items-center gap-4 rounded-[10px] border border-white/10 bg-white/5 px-5 py-4 transition-colors duration-300 hover:border-amber/60"
                  data-testid={r.testid}
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-[8px] border border-white/15 bg-black/30 text-amber">
                    <r.icon size={17} />
                  </span>
                  <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">{r.label}</p>
                    <p className="font-archivo text-sm font-bold text-white transition-colors duration-300 group-hover:text-amberpale">{r.value}</p>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="lg:col-span-7">
          <div className="rounded-[12px] border border-white/10 bg-white/5 px-6 py-3 md:px-9 md:py-5" data-testid="faq-list">
            <Accordion type="single" collapsible>
              {t.faq.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger
                    className="font-archivo text-sm font-bold text-white transition-colors duration-300 hover:text-amber hover:no-underline md:text-base"
                    data-testid={`faq-question-${i}`}
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-white/70" data-testid={`faq-answer-${i}`}>
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
